import React from 'react';
import Logo from './trademark_logo.svg';
import * as S from './Trademark.style';

export default function Trademark(): JSX.Element {
    const curYear = new Date().getFullYear();
    return (
        <S.Container>
            <S.TrademarkLink href="http://www.socialsolutions.com">
                <img src={Logo} alt="social solutions trademark" />
            </S.TrademarkLink>
            <S.TrademarkText>© 2001-{curYear} Social Solutions Global, Inc.</S.TrademarkText>
        </S.Container>
    );
}